/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { EpsiDocDetailResponse } from '../types/EpsiDocDetail';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type EpsiDocsRetrieveRequest = {} | null | undefined;
export type EpsiDocsRetrieveResponse = EpsiDocDetailResponse;

export type EpsiDocsRetrieveQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this epsi doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * GET /dmx-server/epsi_docs/{id}/
 *
 * ```yaml
 * operationId: epsi_docs_retrieve
 * tags:
 *   - epsi_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/EpsiDocDetail'
 *     description: ''
 * ```
 */
export const epsiDocsRetrieveOperation = ({ id, ...rest }: EpsiDocsRetrieveQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/epsi_docs/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/epsi_docs/{id}/' };
  };

/**
 * GET /dmx-server/epsi_docs/{id}/
 *
 * ```yaml
 * operationId: epsi_docs_retrieve
 * tags:
 *   - epsi_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/EpsiDocDetail'
 *     description: ''
 * ```
 */
export const epsiDocsRetrieve = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: EpsiDocsRetrieveQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<EpsiDocDetailResponse>> => {
  const operation = epsiDocsRetrieveOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/epsi_docs/{id}/
 */
export const useEpsiDocsRetrieveResource = (
  query: EpsiDocsRetrieveQuery | null,
  useCached?: boolean,
): UseResource<EpsiDocsRetrieveResponse> => {
  return useResource<EpsiDocsRetrieveResponse>({
    path: query === null ? null : epsiDocsRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
